export default "/images/vendor/flag-icon-css/flags/1x1/td.svg?57c6d2b86e5206f4847a28b447e04789";